import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useFavoriteCarsStore } from '@/stores/favorite-cars'

export const useCarinfoStore = defineStore('car-info', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()
    const favoriteCarsStore = useFavoriteCarsStore()

    const carinfo           = ref({})
    const carinfoProcess    = ref(false)
    const carinfoMsg        = ref({})

    const carinfoUpdateProcess  = ref(false)
    const carinfoUpdateMsg      = ref({})

    async function readCarinfo(uuid) {

        carinfoProcess.value = true
        const token = tokenStore.access

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/${uuid}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                const favorites = await favoriteCarsStore.readFavoriteCars()
                if(favorites.uuidCarArray) {
                    if(favorites.uuidCarArray.includes(request.uuid)) {
                        request.favorite = true
                    }
                }
                carinfo.value = request
                carinfoMsg.value = { success: true }
            } else {
                carinfo.value = {}
                carinfoMsg.value = { success: false, text: request.error }
                carinfoProcess.value = false
                return false
            }

        } else {
            carinfoMsg.value = { success: false, text: 'EToken' }
            carinfoProcess.value = false
            return false
        }

        carinfoProcess.value = false
        return carinfo.value
    } 

    async function updateCarinfo(data) {

        carinfoUpdateProcess.value = true
        const token = tokenStore.access

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars`, 
                method: 'PUT', 
                token,
                data
            })

            if(!request.error) {
                carinfo.value = request
                carinfoUpdateMsg.value = { success: true, text: 'CARINFO_UPDATE_SUCCESS' }
            } else {
                carinfoUpdateMsg.value = { success: false, text: request.error }
                return false
            }

        } else {
            carinfoUpdateMsg.value = { success: false, text: 'EToken' }
            return false
        }

        carinfoUpdateProcess.value = false
        return true
    }

    const setCarinfo            = data => carinfo.value = data
    const setCarinfoUpdateMsg   = data => carinfoUpdateMsg.value = data

    return {
        carinfo,
        carinfoProcess,
        carinfoMsg,
        carinfoUpdateProcess, 
        carinfoUpdateMsg, 
        readCarinfo, 
        updateCarinfo, 
        setCarinfo, 
        setCarinfoUpdateMsg
    }
})
